import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { fetchModelRoutes } from '../api'
import { RouteStatus } from '../types'

export const MODEL_ROUTE_PAGE_SIZE = 10
const SEARCH_DEBOUNCE_MS = 300

export function useModelRouteList() {
  const [status, setStatusState] = useState<RouteStatus>('activated')
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const setStatus = (next: RouteStatus) => {
    setStatusState(next)
    setPage(1)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch((prev) => {
        if (prev !== search) {
          setPage(1)
        }
        return search
      })
    }, SEARCH_DEBOUNCE_MS)
    return () => clearTimeout(timer)
  }, [search])

  const { data, isLoading } = useQuery({
    queryKey: ['modelRoutes', status, debouncedSearch, page],
    queryFn: () =>
      fetchModelRoutes({
        status,
        search: debouncedSearch,
        page,
        pageSize: MODEL_ROUTE_PAGE_SIZE,
      }),
  })

  return {
    status,
    setStatus,
    search,
    setSearch,
    page,
    setPage,
    routes: data?.items ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    pageSize: MODEL_ROUTE_PAGE_SIZE,
  }
}

export type ModelRouteListState = ReturnType<typeof useModelRouteList>
